import React, { useState } from 'react';
import { preferenceGroupSaveService } from '../../services/preferenceGroupSaveService';
import { useTranslation } from 'react-i18next';
import { Toggle } from '@chapche/ui';

const IsAutoAssignedSwitcher = () => {
    const { i18n } = useTranslation();
    const [isAutoAssigned, setIsAutoAssigned] = useState(preferenceGroupSaveService.getPreferenceGroup().isAutoAssigned);

    const switchAutoAssigned = (next) => {
        preferenceGroupSaveService.updatePreferenceGroupAutoAssigned(next);
        setIsAutoAssigned(next);
    };

    return (
        <Toggle
            className="preference__group-label mt-16"
            checked={!!isAutoAssigned}
            onChange={switchAutoAssigned}
            label={i18n.t('app.page.preference.groups.isAutoAssigned')}
        />
    );
};

export default IsAutoAssignedSwitcher;
